
import React from 'react';
import { Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TableView from '../../Components/tableView';
import constants from '../../constants';

const WalletsList = () => {
  const { t } = useTranslation();
  const refTable = React.createRef<TableView>();

  const columns = [
    {
      title: t('WALLET'),
      field: 'account',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('MAIL'),
      field: 'mail',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('NAME'),
      field: 'name',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('SURNAME'),
      field: 'surname',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('SOLANA WALLET'),
      field: 'userSolWalletAddress',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('SNAPSHOT'),
      field: 'snapshotAmount',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('DATE'),
      field: 'date',
      sorter: 'string',
      headerFilter: 'input'
    }
  ];

  return (
      <>
        <Container>
          <TableView
            t={t}
            ref={refTable}
            api={constants.api.getAlgorandAccounts}
            columns={columns}
            id={'transactions'}
            initialSorting={[{ column: 'mail', dir: 'asc' }]}
          />
        </Container>
      </>
  );
};

export default WalletsList;